module.exports = __webpack_public_path__ + "img/制御工学5_7_2.9447ef7b.png";